export enum EmailResult {
  VerifiedEmail = 'verifiedEmail',
  ChangedEmail = 'changedEmail',
}
